const API_PATHS = {
    ROOT: '/ob-api',

    GEN_TOKEN() {
        return `${this.ROOT}/aggregation/v2/partners/authentication`
    },
    ADD_TEST_CUSTOMER() {
        return `${this.ROOT}/aggregation/v2/customers/testing`
    },
    ADD_CUSTOMER() {
        return `${this.ROOT}/aggregation/v2/customers/active`
    },
    GEN_CONNECT_URL() {
        return `${this.ROOT}/connect/v2/generate`
    },
    GET_CUSTOMER_ACCOUNTS(customerId) {
        return `${this.ROOT}/aggregation/v1/customers/${customerId}/accounts`
    },
    GET_CUSTOMER_TRANSACTIONS(customerId, params) {
        return `${this.ROOT}/aggregation/v3/customers/${customerId}/transactions?fromDate=${params.fromDate}&toDate=${params.toDate}&includePending=true`
    },
    GET_CUSTOMER_ACCOUNT_TRANSACTIONS(customerId, accountId, params) {
        return `${this.ROOT}/aggregation/v4/customers/${customerId}/accounts/${accountId}/transactions?fromDate=${params.fromDate}&toDate=${params.toDate}&includePending=true`
    },
    GET_INSTITUTION_BY_ID(institutionId) {
        return `${this.ROOT}/institution/v2/institutions/${institutionId}`
    }
}

export default API_PATHS
